import { render, staticRenderFns } from "./zhiCustomBtn.vue?vue&type=template&id=6b3e4a5a&scoped=true"
import script from "./zhiCustomBtn.vue?vue&type=script&lang=ts"
export * from "./zhiCustomBtn.vue?vue&type=script&lang=ts"
import style0 from "./zhiCustomBtn.vue?vue&type=style&index=0&id=6b3e4a5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e4a5a",
  null
  
)

export default component.exports